var map = {
	"./THB/BAAC.png": "4d7a",
	"./THB/BAY.png": "3671",
	"./THB/BBL.png": "8831",
	"./THB/CIMB.png": "46a7",
	"./THB/CITI.png": "02a5",
	"./THB/DB.png": "d433",
	"./THB/GHB.png": "9dd5",
	"./THB/GSB.png": "1990",
	"./THB/HSBC.png": "15c0",
	"./THB/ICBC.png": "7134",
	"./THB/ISBT.png": "1b53",
	"./THB/KBANK.png": "e093",
	"./THB/KK.png": "7ce8",
	"./THB/KTB.png": "1250",
	"./THB/LHBANK.png": "0c48",
	"./THB/MHCB.png": "10b3",
	"./THB/SCB.png": "4db0",
	"./THB/SCBT.png": "0116",
	"./THB/SMBC.png": "6114",
	"./THB/TBANK.png": "ba25",
	"./THB/TCRB.png": "bd06",
	"./THB/TISCO.png": "69d0",
	"./THB/TMB.png": "93c0",
	"./THB/TSCO.png": "603f",
	"./THB/UOB.png": "0c54",
	"./THB/UOBT.png": "1862",
	"./THB/YBANK.png": "76de",
	"./VND/ABB.png": "de3f",
	"./VND/ACB.png": "6bd0",
	"./VND/BACA.png": "807a",
	"./VND/BFTV.png": "afa0",
	"./VND/BIDV.png": "8825",
	"./VND/BVB.png": "b3a1",
	"./VND/CIMB.png": "c588",
	"./VND/CTG.png": "6a8d",
	"./VND/EACB.png": "e03e",
	"./VND/EIB.png": "2f6f",
	"./VND/GPB.png": "283d",
	"./VND/HDB.png": "f6b3",
	"./VND/HLB.png": "0e62",
	"./VND/HSBC.png": "e2a2",
	"./VND/IBK.png": "69a3",
	"./VND/IVB.png": "ff87",
	"./VND/KLB.png": "b04b",
	"./VND/LVB.png": "a3d9",
	"./VND/MB.png": "052f",
	"./VND/MHB.png": "5c67",
	"./VND/MSB.png": "b67b",
	"./VND/NAMA.png": "9afd",
	"./VND/NCB.png": "ac76",
	"./VND/OCB.png": "5d3a",
	"./VND/OJB.png": "a31c",
	"./VND/PGB.png": "7a74",
	"./VND/PVCOMBANK.png": "37cd",
	"./VND/SBIT.png": "975e",
	"./VND/SCB.png": "8432",
	"./VND/SCVN.png": "e31f",
	"./VND/SEA.png": "a302",
	"./VND/SHB.png": "b7a9",
	"./VND/SHBK.png": "81c2",
	"./VND/TCB.png": "2be4",
	"./VND/TPB.png": "1756",
	"./VND/UOB.png": "a646",
	"./VND/VAB.png": "0327",
	"./VND/VBAA.png": "db1f",
	"./VND/VCB.png": "be49",
	"./VND/VIB.png": "4e2c",
	"./VND/VID.png": "b537",
	"./VND/VIETBANK.png": "d5c5",
	"./VND/VNTT.png": "6154",
	"./VND/VPB.png": "d59e",
	"./VND/VRB.png": "bb3e",
	"./VND/WOO.png": "38d2",
	"./quickpay_bank/THB/BAY.png": "6ee1",
	"./quickpay_bank/THB/BBL.png": "39bc",
	"./quickpay_bank/THB/KBANK.png": "bf70",
	"./quickpay_bank/THB/KTB.png": "b6a0",
	"./quickpay_bank/THB/SCB.png": "b83d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b1ca";